import { useState } from "react";
import { HelpCircle } from "lucide-react";

export default function Tooltip({ text, children }) {
  const [show, setShow] = useState(false);
  return (
    <span
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children || <HelpCircle size={14} color="#0d9488" style={{ cursor: "help", marginLeft: 4 }} />}
      {show && (
        <div style={{
          position: "absolute", top: "calc(100% + 8px)", left: "50%",
          transform: "translateX(-50%)", width: 280, padding: "10px 14px",
          borderRadius: 8, background: "#0f172a", color: "#e2e8f0",
          fontSize: 11, lineHeight: 1.5, zIndex: 9999,
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)", pointerEvents: "none",
        }}>
          <div style={{
            position: "absolute", top: -5, left: "50%",
            transform: "translateX(-50%)", width: 10, height: 10,
            background: "#0f172a", rotate: "45deg",
          }} />
          {text}
        </div>
      )}
    </span>
  );
}
